// VarnasaaraOption3.js - Semantic Color-Coded Brackets Layout

import React from 'react';
import './VarnasaaraOptions.css';

const VarnasaaraOption3 = () => {
  const hardcodedData = [
    {
      text: "वै॒",
      components: [
        {
          type: "consonant",
          character: "व",
          name: "वकार",
          fullDescription: "संवृतकण्ठोत्थित संवार घोष अल्पप्राणाख्य बाह्यप्रयत्नसहित- नादध्वनिजनित, उत्तरदन्तोष्ठस्थान, अन्तरोष्ठान्तकरण ईषत्स्पृष्ट प्रयत्न अर्धमात्रिक, पराङ्गभूत, चन्द्रदेवताक, वैश्यजातिक वकार",
          maatra: "अर्धमात्रिक",
          anga: "पराङ्गभूत",
          svara: ""
        },
        {
          type: "vowel",
          character: "ऐ",
          name: "ऐकार",
          fullDescription: "संवृतकण्ठोत्थित संवाराख्य बाह्यप्रयत्नसहित- नादध्वनिजनित, उपसंहृतकल्प हनुस्थान, तथाभूतौष्ठकरण संवृतप्रयत्न, अर्धमात्रिक अग्नि देवताक, क्षत्रियजातिक, <span class='svara-text'>तमोगुणसहित- कनिष्ठिकांगुल्याद्य रेखान्यास योग्य, शरीर ह्रासैधित गलबिल विनिस्सृत मुदुध्वनिक, शिखिरुत तुल्य, षङ्ज स्वर हेतुभूत हृदयस्थानोत्पन्न, दीर्घानुदात्त स्वरगुणक-</span> आद्यांशभूत अकार- तादृशध्वनिजनित तालुस्थान, जिह्वामध्यकरणविवृतप्रयत्न,अध्यर्धमात्रिक उत्तरांशभूत इकार- उभयांशद्विमात्रिक, अग्निदेवताक, ब्राह्मणजातिक ऐकार",
          maatra: "द्विमात्रिक",
          anga: "",
          svara: "दीर्घानुदात्त"
        }
      ]
    },
    {
      text: "ष्ण॒",
      components: [
        {
          type: "consonant",
          character: "ष",
          name: "षकार द्वित्व",
          fullDescription: "विवृतकण्ठोत्थित विवाराघोष महाप्राणाख्य बाह्यप्रयत्नविशिष्ट श्वासध्वनिजनित, मूर्धस्थान, विवृतमध्य प्रतिवेष्टित जिह्वाग्रकरण, विवृतप्रयत्न अण्वणु मात्रिक, पूर्वाङ्गभूत, अग्निदेवताक, शूद्रजातिक षकार द्वित्व",
          maatra: "अण्वणु मात्रिक",
          anga: "पूर्वाङ्गभूत",
          svara: ""
        },
        {
          type: "consonant",
          character: "ट",
          name: "टकार",
          fullDescription: "विवृतकण्ठोत्थित विवाराघोष अल्पप्राणाख्य बाह्यप्रयत्नविशिष्ट श्वासध्वनिजनित, मूर्धस्थान, प्रतिवेष्टित जिह्वाग्रकरण, स्पृष्ट प्रयत्न अणुमात्रिक, पूर्वाङ्गभूत, वायुदेवताक, ब्राह्मणजातिक, अभिनिधान टकार",
          abhinidhan: "अभिनिधान",
          maatra: "अणुमात्रिक",
          anga: "पूर्वाङ्गभूत",
          svara: ""
        },
        {
          type: "consonant",
          character: "ण",
          name: "णकार",
          fullDescription: "संवृत कण्ठोस्थित संवार घोषाल्पप्राणाख्य बाह्यप्रयत्नसहित- नादध्वनिजनित, विवृतनासिका- मूर्धस्थान, प्रतिवेष्टित जिह्वाग्रकरण, स्पृष्ट प्रयत्न अर्धमात्रिक, पराङ्गभूत, सूर्यदेवताक, वैश्यजातिक णकार",
          maatra: "अर्धमात्रिक",
          anga: "पराङ्गभूत",
          svara: ""
        },
        {
          type: "vowel",
          character: "अ",
          name: "अकार",
          fullDescription: "संवृतकण्ठोत्थित संवाराख्य बाह्यप्रयत्नसहित- नादध्वनिजनित, अत्युपसंहृतकल्प हनुस्थान, तथाभूतौष्ठकरण, संवृतप्रयत्न, एकमात्रिक अग्निदेवताक, क्षत्रियजातिक, <span class='svara-text'>तमोगुणसहित- कनिष्ठिकाङ्गुल्याद्य रेखान्यास योग्य देह ह्रस्वत्वध्वनिमार्दव कण्ठाकाश महत्त्व जनित- वृषरुततुल्य, ऋषभ स्वर हेतुभूत केकीकेकारुततुल्य, षड्ज स्वर हेतुभूत हृदयस्थानोद्भव दृढतरप्रयत्न, विक्रमानुदात्त गुणक,</span> वायुदेवताक, ब्राह्मणजातिक अकार",
          maatra: "एकमात्रिक",
          anga: "",
          svara: "विक्रमानुदात्त"
        }
      ]
    },
    {
      text: "वी",
      components: [
        {
          type: "consonant",
          character: "व",
          name: "वकार",
          fullDescription: "संवृतकण्ठोत्थित संवार घोष अल्पप्राणाख्य बाह्यप्रयत्नसहित- नादध्वनिजनित, उत्तरदन्तोष्ठस्थान, अन्तरोष्ठान्तकरण ईषत्स्पृष्ट प्रयत्न अर्धमात्रिक, पराङ्गभूत, चन्द्रदेवताक, वैश्यजातिक वकार",
          maatra: "अर्धमात्रिक",
          anga: "पराङ्गभूत",
          svara: ""
        },
        {
          type: "vowel",
          character: "ई",
          name: "ईकार",
          fullDescription: "संवृतकण्ठोत्थित संवाराख्य बाह्यप्रयत्नसहित- नादध्वनिजनित, तालुस्थान, अत्युपसंहृतकल्प ओष्ठसहित- जिह्वामध्यकरण, विवृतप्रयत्न, द्विमात्रिक भूमिदेवताक ब्राह्मणजातिक <span class='svara-text'>सत्वगुणसहित तर्जन्यंगुलि मध्यरेखान्यासयोग्य, शरीरायाम श्लक्ष्णीकृत गलबिलविनिस्सृत परुषध्वनिक अजारुत तुल्य गान्धारस्वर हेतुभूत मूर्धस्थानोत्पन्न उदात्तस्वरगुणक,</span>  अग्निदेवताक, ब्राह्मणजातिक ईकार",
          maatra: "द्विमात्रिक",
          anga: "",
          svara: "उदात्त"
        }
      ]
    },
    {
      text: "म्",
      components: [
        {
          type: "consonant",
          character: "म",
          name: "मकार",
          fullDescription: "संवृतकण्ठोत्थित संवार घोष अल्पप्राणाख्य बाह्यप्रयत्नसहित- नादध्वनिजनित, विवृतनासिका- उत्तरोष्ट स्थाना धरोष्ठ करण, स्पृष्ट प्रयत्न अर्धमात्रिक, पराङ्गभूत, सूर्यदेवताक, वैश्यजातिक, नादसंज्ञक मकार",
          maatra: "अर्धमात्रिक",
          anga: "पराङ्गभूत",
          svara: ""
        }
      ]
    }
  ];

  const renderComponent = (component, index) => {
    const bracketClass = `bracket-${component.type}`;
    
    return (
      <span key={index} className="component-bracket-group">
        <span className={`bracket ${bracketClass}`}>[</span>
        <span className="component-content">
          <span className="component-label">{component.character} -</span>
          <span className="component-description" dangerouslySetInnerHTML={{__html: component.fullDescription}} />
        </span>
        <span className={`bracket ${bracketClass}`}>]</span>
        {' '}
      </span>
    );
  };

  return (
    <div className="varnasaara-option3">
      <h4 className="mb-3">Option 3: Color-Coded Brackets</h4>
      <div className="word-display mb-3">
        <h5>वैष्णवीम्</h5>
      </div>
      
      <div className="bracket-legend mb-3">
        <span className="legend-item">
          <span className="bracket bracket-consonant">[</span>
          <span>हल्</span>
          <span className="bracket bracket-consonant">]</span>
        </span>
        <span className="legend-item">
          <span className="bracket bracket-vowel">[</span>
          <span>अच्</span>
          <span className="bracket bracket-vowel">]</span>
        </span>
      </div>
      
      {hardcodedData.map((syllable, syllableIndex) => (
        <div key={syllableIndex} className="syllable-block mb-4">
          <div className="syllable-line">
            <span className="syllable-text">{syllable.text} </span>
            
            {syllable.components.map((component, componentIndex) => 
              renderComponent(component, componentIndex)
            )}
            
            {syllableIndex === 0 && (
              <span className="virama-text">अणुमात्रिक विराम </span>
            )}
            {syllableIndex === 1 && (
              <span className="virama-text">अणुमात्रिक विराम </span>
            )}
            {syllableIndex === 2 && (
              <span className="virama-text">अणुमात्रिक विराम </span>
            )}
            {syllableIndex === hardcodedData.length - 1 && (
              <span className="virama-text">द्विमात्रिक विरामाः।</span>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default VarnasaaraOption3;
